import React, { useImperativeHandle, useRef } from 'react'
import { Formik, Form } from 'formik'
import { userInviteValidation } from './validation'
import { Card } from 'app/components/ui/Card'
import styled from 'styled-components'
import { SmartInput } from 'app/components/formik/Input'
import { ApiErrorMessage } from 'app/components/ui/form/ApiErrorMessage'
import { ApiError } from 'EstraSuppliers'
import { GetDataError } from 'restful-react'

export type SignupFormValues = {
  email: string
  password: string
  passwordConfirmation: string
}

interface Props {
  initialValues: SignupFormValues
  onSignupRequest: (values: SignupFormValues) => void
  // isLoading: boolean
  error?: GetDataError<ApiError> | null
}

// ForwardRef is used to pass the submitForm function back to the parent, as the button  is outside this component
export const FormUserInvite = React.forwardRef<() => void, Props>(
  (
    {
      initialValues,
      onSignupRequest,
      // isLoading,
      error,
    },
    ref
  ) => {
    // Get ref of form to submit programatically
    const userInviteFormRef = useRef() as Fixme

    const submitForm = () => {
      userInviteFormRef.current.handleSubmit()
    }

    useImperativeHandle(ref, () => submitForm, [])

    return (
      <Formik
        innerRef={userInviteFormRef}
        initialValues={initialValues}
        validate={userInviteValidation}
        onSubmit={values => {
          // send
          onSignupRequest(values)
        }}
      >
        {() => {
          return (
            <Form>
              <Card bgColor='white' padding='2rem 2rem 1rem 2rem'>
                {/* EMAIL */}
                <InputGroup>
                  <SmartInput
                    readOnly={true}
                    label='Indirizzo email'
                    name='email'
                    type='email'
                    placeholder='Inserisci la tua mail personale'
                  />
                </InputGroup>

                {/* PASSWORD */}
                <InputGroup>
                  <SmartInput
                    label='Password *'
                    name='password'
                    type='password'
                    placeholder='Inserisci la password'
                  />
                </InputGroup>

                {/* CONFIRM PASSWORD */}
                <InputGroup>
                  <SmartInput
                    label='Conferma Password *'
                    name='passwordConfirmation'
                    type='password'
                    placeholder='Conferma la password'
                  />
                </InputGroup>
              </Card>
              <ErrorWrapper>
                {error && (
                  <UserInviteError outline error={error}></UserInviteError>
                )}
              </ErrorWrapper>
            </Form>
          )
        }}
      </Formik>
    )
  }
)

FormUserInvite.displayName = 'FormUserInvite' // Typescript workaround for ForwardRef Component

const InputGroup = styled.div`
  margin-bottom: 2rem;
`

const ErrorWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const UserInviteError = styled(ApiErrorMessage)`
  margin-bottom: 1rem;
`
